import { render } from "./DatabaseItem.vue?vue&type=template&id=60ae6b1e&scoped=true"
import script from "./DatabaseItem.vue?vue&type=script&lang=js"
export * from "./DatabaseItem.vue?vue&type=script&lang=js"

import "./DatabaseItem.vue?vue&type=style&index=0&id=60ae6b1e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ae6b1e"]])

export default __exports__